
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        padding: "0 15px",
        height: '58px',
        "& h2": {
            padding: '0px 15px',
            // fontSize: '22px',
            // fontWeight: 600,
            // lineHeight: '28.8px',
            // color: '#2D4D95',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 600,
             fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
            lineHeight: '29px',
            color: '#2D4D95',
        }
    },
    container: {
        padding: '10px',
    },
    root: {
        width: 65,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(38px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `0px solid ${theme.palette.grey[400]}`,
        backgroundColor: '#c3c3c3',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},

    alignItemsRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
    },
    
    mobileTableList: {
        display: 'flex',
        flexFlow: 'wrap',
        margin: '8px 0',
        background: '#F0F0F0',
        padding: '12px 5px',
        borderRadius: '10px',
        fontSize: '16px',
        "& div": {
            padding: '0 10px',
        },
        "&:nth-child(even)": {
            background: '#DCECFF',

        }
    },
    greyBorderBox: {
        border: '1px solid #e3e3e3',
        padding: '20px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        margin: '5px',
        flexFlow: 'column',
        minHeight: '270px',
        borderRadius: '19px',
        "& h3": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '28px',
            lineHeight: '39px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#3C4549',
            margin: '18px 0px',
        },
        "& img": {
            marginTop: '20px'
        }
    },
    table: {
        marginBottom: window.isIpadView? '80px': '',
    },
    changeBtn: {
        fontSize: window.isMobileView ? window.isMobile425 ? '8px' : '10px' : '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '6px',
        marginRight: '5px',
        padding: window.isMobileView ? window.isMobile425 ? '4px 8px' : '6px 12px' : '8px 16px',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        textWrap: 'nowrap',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    SearchBar:{
        backgroundColor: '#fff',
        backgroundImage: 'none',
        border: '1px solid #d9d9d9',
        borderRadius: '2px',
    }

}))